// React
import React from 'react';

// Mantine
import { Modal } from '@mantine/core';
import { MRT_TableInstance } from 'mantine-react-table';

// Interfaces
import { Claim } from 'interfaces';

// Components
import { ClaimQueryModalContent } from './ClaimQueryModalContent';

interface ClaimQueryModalProps {
  opened: boolean;
  close: () => void;
  selectedClaim: Claim | null;
  table?: MRT_TableInstance<Claim>;
}

export const ClaimQueryModal: React.FC<ClaimQueryModalProps> = ({
  opened,
  close,
  selectedClaim,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      size="xl"
      data-testid={'claim-query-modal'}
      style={{ backgroundColor: 'transparent' }}
    >
      <Modal.Title
        style={{
          fontSize: 30,
          fontWeight: 500,
          textAlign: 'center',
          paddingBottom: 25,
        }}
      >
        Claim Query
      </Modal.Title>
      {selectedClaim ? (
        <ClaimQueryModalContent selectedClaim={selectedClaim} onClose={close} />
      ) : null}
    </Modal>
  );
};
